import { WarningOutlined } from '@ant-design/icons'
import { Modal, Tooltip } from 'antd'
import { useEffect, useState } from 'react'

import Loader from '@/components/Atoms/Loader/Loader'
import { SubscriberDto } from '@/types'
import api from '@/utils/api/api'

import cn from './SubscribersModal.module.scss'

type Props = {
  eventType: string | null
  eventLabel?: string
  onClose: () => void
}

function SubscribersModal({ eventType, eventLabel, onClose }: Props) {
  const [subscribers, setSubscribers] = useState<SubscriberDto[]>([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!eventType) return
    setLoading(true)
    api
      .get(`/notifications/subscriptions/types/${eventType}/subscribers`)
      .then((r) => setSubscribers(r.data.subscribers ?? []))
      .catch(() => setSubscribers([]))
      .finally(() => setLoading(false))
  }, [eventType])

  return (
    <Modal
      open={!!eventType}
      onCancel={onClose}
      title={eventType ? (eventLabel ?? eventType) : ''}
      footer={null}
      centered
      className={cn.modal}
      destroyOnHidden
    >
      {loading ? (
        <div className={cn.loader}>
          <Loader size={24} />
        </div>
      ) : subscribers.length === 0 ? (
        <div className={cn.empty}>Нет подписчиков</div>
      ) : (
        <ul className={cn.list}>
          {subscribers.map((s) => (
            <li key={s.user.id} className={cn.item}>
              <div className={cn.userInfo}>
                <span className={cn.userName}>{s.user.description}</span>
                <span className={cn.userLogin}>{s.user.login}</span>
              </div>
              {!s.telegramActivated && (
                <Tooltip title="Пользователь не подключил бота">
                  <WarningOutlined className={cn.warnIcon} />
                </Tooltip>
              )}
            </li>
          ))}
        </ul>
      )}
    </Modal>
  )
}

export default SubscribersModal
